import { ref } from '@vue/composition-api';

const error = ref(null);
export default function() {
  return {
    error
  };
}
